import React, { useEffect, useState } from 'react'
import { CustomModal, InputText } from '../../../../components'
import { formatDateToLocale } from '../../../../services/util/date.service'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { getDeliveriesAssociadasBip } from '../../../../services/api/https/picking/picking.http'

const formatDateTime = value => {
  if (!value || value === '-') return ''

  try {
    return formatDateToLocale(value, 'dd/MM/yy HH:mm:ss').toFormat('dd/MM/yy HH:mm:ss')
  } catch (e) {
    return ''
  }
}

export default function TabBipsExcluidosModal({ visible, onClose, bip, pickingId }) {
  const [deliveries, setDeliveries] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (visible && bip && bip.product_code && bip.area) {
      buscarDeliveriesAssociadas()
    }
  }, [visible, bip])

  const buscarDeliveriesAssociadas = async () => {
    try {
      setLoading(true)
      const response = await getDeliveriesAssociadasBip(pickingId, bip.product_code, bip.area)
      setDeliveries(response || [])
    } catch (error) {
      console.error('Erro ao buscar deliveries associadas:', error)
      setDeliveries([])
    } finally {
      setLoading(false)
    }
  }

  return (
    <CustomModal onClose={onClose} isVisible={visible} header={'Informações do BIP'}>
      <div className="p-grid" style={{ maxWidth: 800, maxHeight: '80vh', overflowY: 'auto' }}>
        <div className="p-col-12">
          <InputText
            value={bip ? formatDateTime(bip.horario) : ''}
            disabled={true}
            label={'Horário da bipagem:'}
            marginTop={0}
          />
        </div>
        <div className="p-col-12">
          <InputText
            value={bip && bip.bipado_por ? bip.bipado_por : ''}
            disabled={true}
            label={'Bipado por:'}
            marginTop={0}
          />
        </div>
        <div className={bip && bip.uni !== 0 ? 'p-col-12 p-md-8' : 'p-col-12 p-md-10'}>
          <InputText
            value={bip ? bip.produto : ''}
            disabled={true}
            label={'Produto:'}
            marginTop={0}
          />
        </div>
        <div className={bip && bip.uni !== 0 ? 'p-col-6 p-md-2' : 'p-col-12 p-md-2'}>
          <InputText value={bip ? bip.vol : ''} disabled={true} label={'Vol:'} marginTop={0} />
        </div>
        {bip && bip.uni !== 0 && (
          <div className="p-col-6 p-md-2">
            <InputText value={bip.uni} disabled={true} label={'Uni:'} marginTop={0} />
          </div>
        )}
        <div className="p-col-12 p-md-4">
          <InputText value={bip ? bip.area : ''} disabled={true} label={'Área:'} marginTop={0} />
        </div>
        <div className="p-col-12 p-md-4">
          <InputText
            value={bip && bip.apelido ? bip.apelido : ''}
            disabled={true}
            label={'Apelido:'}
            marginTop={0}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <InputText
            value={bip ? bip.equipe : ''}
            disabled={true}
            label={'Equipe:'}
            marginTop={0}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <InputText
            value={bip && bip.pallet_area_id ? bip.pallet_area_id : ''}
            disabled={true}
            label={'Núm. Pallet:'}
            marginTop={0}
          />
        </div>
        <div className="p-col-12 p-md-8">
          <InputText
            value={bip && bip.lote ? bip.lote : ''}
            disabled={true}
            label={'Lote(s):'}
            marginTop={0}
          />
        </div>
        <div className="p-col-12 p-md-12">
          <InputText
            value={bip && bip.info_complementar ? bip.info_complementar : ''}
            disabled={true}
            label={'Info. Complementar:'}
            marginTop={0}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <InputText
            value={bip && bip.data_fabricacao ? bip.data_fabricacao : ''}
            disabled={true}
            label={'Data de Fabricação:'}
            marginTop={0}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <InputText
            value={bip && bip.data_validade ? bip.data_validade : ''}
            disabled={true}
            label={'Data de Validade:'}
            marginTop={0}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <InputText
            value={bip && bip.bip_codigo_ativacao ? bip.bip_codigo_ativacao : ''}
            disabled={true}
            label={'BIP - Código de Ativação:'}
            marginTop={0}
          />
        </div>

        <div className="p-col-12" style={{ marginTop: 20 }}>
          <h4 style={{ marginBottom: 10 }}>Informações da exclusão</h4>
        </div>
        <div className="p-col-12 p-md-4">
          <InputText
            value={bip ? formatDateTime(bip.horario_exclusao) : ''}
            disabled={true}
            label={'Horário da Exclusão:'}
            marginTop={0}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <InputText
            value={bip && bip.excluido_por ? bip.excluido_por : ''}
            disabled={true}
            label={'Excluído Por:'}
            marginTop={0}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <InputText
            value={bip && bip.codigo_ativacao ? bip.codigo_ativacao : ''}
            disabled={true}
            label={'Exclusão - Código de Ativação:'}
            marginTop={0}
          />
        </div>

        <div className="p-col-12" style={{ marginTop: 20 }}>
          <h4 style={{ marginBottom: 10 }}>Notas Associadas</h4>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>Carregando...</div>
          ) : (
            <DataTable
              value={deliveries}
              emptyMessage="Nenhuma nota associada"
              paginator={deliveries.length > 5}
              rows={5}
              style={{ fontSize: '0.9em' }}
            >
              <Column field="nota" header="Nota" style={{ width: '30%' }} />
              <Column field="nomeFantasia" header="Nome Fantasia" style={{ width: '45%' }} />
              <Column field="cidade" header="Cidade" style={{ width: '25%' }} />
            </DataTable>
          )}
        </div>
      </div>
    </CustomModal>
  )
}
